// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"b3e55e8af83353401608","245":"50ba0fa18ee1fd1a65b1","452":"65fae9ad63712825fb61","453":"9740657d121d76f1cb5d"}[chunkId] + ".js";
};